exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ingredients-list{font-size:1.75rem;text-align:center}#ingredients-list ul{border-top:2px solid #f5f5f5;transition:border-top-color .25s}#ingredients-list ul.active{border-top-color:#dcdcdc}#ingredients-list li{display:flex;justify-content:space-between;padding:0 10px 10px}.delete{color:#2c3e50;cursor:pointer}#search-button{color:inherit;background-color:transparent;border:1px solid #2c3e50;border-radius:4px;box-shadow:2px 2px #2c3e50;cursor:pointer;margin:2rem;padding:5px 50px;font-size:1.75rem;transition:all .25s}#search-button:hover{background-color:#dcdcdc}#search-button:disabled{color:#4f4f4f;cursor:default;background-color:#f5f5f5;box-shadow:0 0 transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1152f177","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ingredients-list.vue
// module id = 29
// module chunks = 0